import ChequeDetails from "./ChequeDetails";

export default ChequeDetails;
